// package
import { common, config } from "includes";
import { forwardRef, useEffect } from "react";
import { Button } from "react-bootstrap";

const Facebook = forwardRef((props: any, ref: any) => {

  // effect
  useEffect(() => {
    const initFacebookSDK = () => {
      (window as any).fbAsyncInit = () => {
        (window as any).FB.init({
          appId: config.fbAppId,
          cookie: true,
          xfbml: true,
          version: "v18.0",
        });
      };

      const script = document.createElement("script");
      script.src = "https://connect.facebook.net/en_US/sdk.js";
      script.async = true;
      script.defer = true;
      document.body.appendChild(script);
    };

    initFacebookSDK();
  }, []);

  // event
  // Only the login happens in the browser. The page list and page tokens are
  // fetched by the API (POST admin/locality/:id/facebook/link), because those
  // Graph calls need the app secret, which must not ship in the bundle.
  const handleFacebookLogin = (e: any) => {
    e.preventDefault();
    if (!(window as any).FB) {
      common.notify("E", "Facebook is still loading. Try again in a moment.");
      return;
    }
    (window as any).FB.login(
      (response: any) => {
        const accessToken = response?.authResponse?.accessToken;
        if (accessToken) {
          props.setFBPage(accessToken);
        } else {
          common.notify("E", "Facebook login was cancelled or not fully authorised.");
        }
      },
      {
        scope: [
          "public_profile",
          "email",
          "pages_manage_posts",
          "pages_manage_metadata",
          "pages_read_engagement",
          "pages_read_user_content",
          "pages_show_list",
        ].join(","),
      }
    );
  };

  return (
    <div>
      <Button variant="primary" onClick={handleFacebookLogin}>Link a Facebook Page</Button>
    </div>
  );
});

export default Facebook;

